export const setActiveMenuItem = (id) => {
  $('.main-nav__item').removeClass('active');
  $('.main-nav__item[data-target="' + id + '"]').addClass('active');
}


export const setOffset = (items, offset) => {
  let transform = 150;
  items.each((i, el) => {
    if (offset) {
      transform = 150 + (i * offset);
    }
    $(el).css({ transform: 'translateX(' + transform + 'px)', opacity: 0 });
  });
}

export const clearOffset = (items, offset) => {
  items.css({ transform: '', opacity: '' });
}


export const titleAnimation = (title) => {
  if (title) {
    $('#pagetitle').empty('.menu-letter');

    let menuArr = [];

    menuArr.push(title.split(''));

    let menuLetters = menuArr[0];

    for (let i = 0; i < menuLetters.length; i++) {
      let menuLetter = document.createElement('span');
      menuLetter.className = 'menu-letter';
      menuLetter.innerHTML = menuLetters[i];
      $('#pagetitle').append(menuLetter)
    }

    let menuLetterDiv = document.getElementsByClassName('menu-letter');
    let menuLetterLength = menuLetterDiv.length;
    let menuCount = 0;

    function menuAnimation() {
      var element = menuLetterDiv[menuCount];
      if (element) {
        element.className += ' menu-letter-display';
        menuCount++;

        if (menuCount === menuLetterLength) {
          clearInterval(menuInterval);
        }
      }
      else {
        return
      }
    }

    var menuInterval = setInterval(menuAnimation, 25);
  }
}



// WEBPACK FOOTER //
// ./src/js/utils/ScrollUtils.js